import { render, staticRenderFns } from "./StepBasicEditor.vue?vue&type=template&id=8e1c9a48&scoped=true"
import script from "./StepBasicEditor.vue?vue&type=script&lang=js"
export * from "./StepBasicEditor.vue?vue&type=script&lang=js"
import style0 from "./StepBasicEditor.vue?vue&type=style&index=0&id=8e1c9a48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1c9a48",
  null
  
)

export default component.exports